import { useState } from 'react';
import { Group, Image, Modal, UnstyledButton } from '@mantine/core';

interface JobPicturesProps {
  pictures?: string[];
}

export default function JobPictures({ pictures }: JobPicturesProps) {
  const [openedUrl, setOpenedUrl] = useState<string | null>(null);

  if (!pictures?.length) {
    return null;
  }

  return (
    <>
      <Group gap="sm" wrap="wrap">
        {pictures.map((src) => (
          <UnstyledButton
            key={src}
            onClick={() => setOpenedUrl(src)}
            aria-label="Open job picture"
          >
            <Image
              src={src}
              alt="Job description"
              mah={128}
              maw={200}
              w="auto"
              fit="contain"
              radius="sm"
            />
          </UnstyledButton>
        ))}
      </Group>
      <Modal
        opened={openedUrl != null}
        onClose={() => setOpenedUrl(null)}
        centered
        size="auto"
        withCloseButton
        padding="sm"
      >
        {openedUrl && (
          <Image
            src={openedUrl}
            alt="Full job description"
            fit="contain"
            mah="90vh"
            maw="90vw"
          />
        )}
      </Modal>
    </>
  );
}
